export const useApi = <T>(request: Parameters<typeof useFetch<T>>[0], opts?: Parameters<typeof useFetch<T>>[1]) => {
  return useFetch<T>(request, {
    ...opts,
    $fetch: useNuxtApp().$api as typeof $fetch
  });
};

export const $api = <T>(request: Parameters<typeof $fetch<T>>[0], opts?: Parameters<typeof $fetch<T>>[1]) => {
  const api = useNuxtApp().$api as typeof $fetch<T>;

  return api(request, opts);
};
